/* import RequireAuth from '../auth' */

export default [
  {
		name: "Videocall",
		path: "/videocall/:roomId",
		components: {
			appView: () => import('../../views/Videocall'),
		},
		props: {
			appView: true
		},
		/* beforeEnter: RequireAuth, */
		meta: {
			requiresAuth: true,
			access_control: ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_MANAGER'],
		},
	}
]
